import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../store/authStore';

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { token, user } = useAuth();
    const location = useLocation();
    if (!token) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    if (adminOnly && user?.role !== 'admin') {
        return <Navigate to="/home" replace />;
    }
    return children;
}
